// Formatters y clases de badge compartidos por las vistas de Informes de Meta.
export const DELIVERY_THRESHOLD = 95;

const numberFormatter = new Intl.NumberFormat('es-AR');
const decimalFormatter = new Intl.NumberFormat('es-AR', {
  maximumFractionDigits: 1,
});

export const fmt = value => numberFormatter.format(Math.round(value || 0));

export const fmtPct = value => `${decimalFormatter.format(value || 0)}%`;

export const rateColorClass = rate => {
  if (rate >= 98) return 'text-green-600 dark:text-green-500';
  if (rate >= DELIVERY_THRESHOLD) return 'text-amber-600 dark:text-amber-500';
  return 'text-red-600 dark:text-red-500';
};

export const statusBadgeClass = status => {
  const base = 'px-2 py-0.5 rounded text-xs font-medium ';
  switch ((status || '').toUpperCase()) {
    case 'APPROVED':
      return `${base}bg-green-100 text-green-700 dark:bg-green-950/40 dark:text-green-400`;
    case 'PAUSED':
    case 'PENDING':
      return `${base}bg-amber-100 text-amber-700 dark:bg-amber-950/40 dark:text-amber-400`;
    case 'REJECTED':
    case 'DISABLED':
      return `${base}bg-red-100 text-red-700 dark:bg-red-950/40 dark:text-red-400`;
    default:
      return `${base}bg-slate-100 dark:bg-slate-800`;
  }
};

const STATUS_KEYS = [
  'APPROVED',
  'PENDING',
  'REJECTED',
  'PAUSED',
  'DISABLED',
  'IN_APPEAL',
  'PENDING_DELETION',
  'DELETED',
  'FLAGGED',
  'LIMIT_EXCEEDED',
];

// Etiqueta traducida del estado; cae al valor crudo si Meta manda algo nuevo.
export const statusLabel = (status, t) => {
  const key = (status || '').toUpperCase();
  return STATUS_KEYS.includes(key)
    ? t(`META_REPORTS.TEMPLATES.STATUS_LABELS.${key}`)
    : status || '—';
};

const QUALITY_BUCKET = {
  GREEN: 'GREEN',
  HIGH: 'GREEN',
  YELLOW: 'YELLOW',
  MEDIUM: 'YELLOW',
  RED: 'RED',
  LOW: 'RED',
};

// Calidad traducida; sin dato o UNKNOWN → "Pendiente".
export const qualityLabel = (score, t) => {
  const bucket = QUALITY_BUCKET[(score || '').toUpperCase()] || 'UNKNOWN';
  return t(`META_REPORTS.TEMPLATES.QUALITY_LABELS.${bucket}`);
};

export const qualityBadgeClass = score => {
  const base = 'px-2 py-0.5 rounded text-xs font-medium ';
  switch ((score || '').toUpperCase()) {
    case 'GREEN':
    case 'HIGH':
      return `${base}bg-green-100 text-green-700 dark:bg-green-950/40 dark:text-green-400`;
    case 'YELLOW':
    case 'MEDIUM':
      return `${base}bg-amber-100 text-amber-700 dark:bg-amber-950/40 dark:text-amber-400`;
    case 'RED':
    case 'LOW':
      return `${base}bg-red-100 text-red-700 dark:bg-red-950/40 dark:text-red-400`;
    default:
      return `${base}bg-slate-100 dark:bg-slate-800`;
  }
};
